import { gql } from 'graphql-tag';
import { useQuery } from '@apollo/client';

export const GetUserProfileCertificatesQuery = gql`
  query userProfileCertificates($userUri: String!) {
    userNudges(userUri: $userUri) {
      id
      certificateNudges {
        nudgeId
        name
        authority
        issueDate
        expiryDate
      }
    }
  }
`;

export const useUserProfileCertificates = ({ userUri, skip }) => {
  const { data, loading, error } = useQuery(GetUserProfileCertificatesQuery, {
    variables: {
      userUri
    },
    fetchPolicy: 'cache-and-network',
    skip: !userUri || skip
  });

  return {
    userProfileCertificates: data?.userNudges?.certificateNudges || [],
    loading,
    error
  };
};

export default useUserProfileCertificates;
